import React from 'react';

/**
 * CLIMATECO2RE Logo
 * Wordmark: "CLIMATEC" + official sunburst icon (as the "O") + subscript "2" + "RE"
 * Uses the user's actual uploaded icon (background made transparent), served from /public.
 */

const ICON_URL = '/climatecore-icon.png';

const Logo = ({ height = 36, dark = false, className = '' }) => {
  const textColor = dark ? '#FFFFFF' : '#2B2B2B';
  const fontSize = height * 0.82;
  const iconSize = height * 1.15;

  return (
    <div
      className={`flex items-center select-none ${className}`}
      style={{ height }}
      aria-label="CLIMATECO2RE"
      data-testid="brand-logo"
    >
      <span
        style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: `${fontSize}px`,
          letterSpacing: '-0.01em',
          color: textColor,
          lineHeight: 1,
        }}
      >
        CLIMATEC
      </span>

      {/* Official sunburst icon replacing the "O" */}
      <img
        src={ICON_URL}
        alt=""
        aria-hidden="true"
        style={{
          height: `${iconSize}px`,
          width: `${iconSize}px`,
          objectFit: 'contain',
          margin: `0 ${height * 0.005}px`,
        }}
      />

      {/* subscript 2 */}
      <span
        style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: `${fontSize * 0.5}px`,
          color: textColor,
          alignSelf: 'flex-end',
          marginBottom: `${height * 0.05}px`,
          marginRight: `${height * 0.02}px`,
        }}
      >
        2
      </span>

      <span
        style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 600,
          fontSize: `${fontSize}px`,
          letterSpacing: '-0.01em',
          color: textColor,
          lineHeight: 1,
        }}
      >
        RE
      </span>
    </div>
  );
};

export default Logo;
